import { render } from "./AccY.vue?vue&type=template&id=7b948c94"
import script from "./AccY.vue?vue&type=script&lang=js"
export * from "./AccY.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__